import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

$.fn.serializeObject = function()
{
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

class FilterSentence extends Component {
    constructor(props){
        super(props);
        this.renderSelectFilter = this.renderSelectFilter.bind(this);
    }
    renderSelectFilter(id){
        this.props.lang.interface_lang.results.forEach((item)=>{
            if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                return false
            }else{
                if($('#'+id).find('option#'+item.id).length){
                    return false
                }else{
                    $('#'+id).append($('<option>', {
                        value: item.id,
                        text : item.lang.name,
                        id : item.id
                    }));
                }
                // return(
                //     <option key={item.lang.id} value={item.lang.id}>{item.lang.name}</option>
                // )
            }
        })
        $('.selectpicker').selectpicker('refresh')
    }

    render() {
        return (
            <form id="searchSentence" className="clearfix">
                <input type="text" name="flangs" value={this.props.id} hidden="hidden" onChange={this.props.filterInput}/>
                <div className="col-md-4 pull-left">
                    <div className="input-group search_block">
                        <span className="input-group-addon glyphicon glyphicon-search"></span>
                        <input type="text" name="phrase" className="form-control" placeholder="Search" aria-describedby="Search" onChange={_.debounce(this.props.filterInput, 500)}/>
                    </div>
                </div>
                <div className="col-md-8 pull-right">
                    <div className="pull-left mr20">
                        <select className="selectpicker" name="study_type" id="study_type" defaultValue="selectDefault" data-live-search="true" onChange={this.props.filterInput}>
                            <option value="selectDefault">Select function</option>
                            <option value="1">Memorise</option>
                            <option value="2">Writing</option>
                            <option value="3">Speaking</option>
                        </select>
                    </div>
                    <div className="pull-left mr20">
                        <select className="selectpicker" name="woblang" id="Without" defaultValue="selectDefault" data-live-search="true" onChange={this.props.filterInput}>
                            <option value="selectDefault">Without translation into</option>
                            {this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.interface_lang.results ? this.renderSelectFilter('Without') : ""}
                        </select>
                    </div>
                    <div className="pull-left">
                        <select className="selectpicker" name="wblang" id="into" defaultValue="selectDefault" data-live-search="true" onChange={this.props.filterInput}>
                            <option value="selectDefault">Translated into</option>
                            {this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.interface_lang.results ? this.renderSelectFilter('into') : ""}
                        </select>
                    </div>
                </div>
            </form>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}

export default connect(mapStateToProps, null)(FilterSentence);


// WEBPACK FOOTER //
// ./src/components/filterSentence.js